import {
  getNodeList,
  isNumberNode,
  isStringNode,
  NumberNode,
  Plugin,
  StringNode,
  ValueNode,
} from '@sagold/react-json-editor';

type ReadonlyValueFormatter<T extends ValueNode> = (
  node: T
) => T['value'] | string | undefined;

export type ReadonlyFormattingPluginOptions = {
  stringFormatter: ReadonlyValueFormatter<StringNode>;
  dateFormatter: ReadonlyValueFormatter<StringNode>;
  numberFormatter: ReadonlyValueFormatter<NumberNode>;
};

export const ReadonlyFormattingPlugin: Plugin<
  ReadonlyFormattingPluginOptions
> = (he, { numberFormatter, stringFormatter, dateFormatter }) => {
  const readonlyNodes = getNodeList(he.root).filter((node) => {
    return node.options.readOnly;
  });

  // Always return an empty validation error array for readonly values
  for (const [key, validator] of Object.entries(he.draft.validateFormat)) {
    he.draft.validateFormat[key] = (node, value) => {
      if (node.schema.options.readOnly) {
        return [];
      }
      return validator(node, value);
    };
  }

  for (const node of readonlyNodes) {
    if (isStringNode(node)) {
      // Use string type to prevent json schema validation
      // e.g. formatting number with postfix as string
      node.schema.type = ['string', 'null'];
      if (node.schema.format === 'date') {
        he.setValue(node.pointer, dateFormatter(node));
      } else {
        he.setValue(node.pointer, stringFormatter(node));
      }
    } else if (isNumberNode(node)) {
      // Use string type to prevent json schema validation
      // e.g. formatting number with postfix as string
      node.schema.type = ['string', 'null'];
      he.setValue(node.pointer, numberFormatter(node));
    }
  }

  return {
    id: 'readonly-formatting-plugin',
    onEvent() {
      return undefined;
    },
  };
};
